import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import styles from "./seek.module.scss";
import { Form, Button, Grid, Input, Container } from "semantic-ui-react";
import { seeklimits } from "actions/seek";
import Suggestion from "./Suggestions";
import _ from "lodash";
import cx from "classnames";
import { toast } from "react-toastify";
export default function Seek() {
  const account = useSelector((state) => state.accounts.account);
  const limitChange = useSelector((state) =>
    _.get(state, "accounts.account.limit", 0)
  );
  const [initialRender, setInitialRender] = useState(true);
  const [disableSaveButton,setDisableSaveButton] = useState(true);
  const [limit, setSeekLimit] = useState(0);
  const [fliteViewSeekLimit, setFliteViewSeekLimit] = useState(0);

  const dispatch = useDispatch();
  const seekSubscription = useSelector(
    (state) => state.accounts.seekSubscription
  );
  useEffect(() => {
    if (account) {
        setSeekLimit(_.get(account, "limit", 0));
        setFliteViewSeekLimit(_.get(account, "visitorLimit", 0));  
    }
  }, [account]);
  useEffect(() => {
    if (!initialRender && !seekSubscription.updating) {
      if (seekSubscription.success) {
        toast.success(`${account.name} limit updated`);
      } else {
        toast.error(`failed to update ${account.name} limit`);
      }
    }
  }, [seekSubscription]);

  setTimeout(() => {
    setInitialRender(false);
  }, 3000);
  const handleSaveClick = () => {
    setDisableSaveButton(true);
    dispatch(
      seeklimits({
        visitorLimit:fliteViewSeekLimit,
        userLimit:limit,
        id: account.id,
      })
    )
  };

  const handleSeekClick =  (value) => {
    setSeekLimit(value < 0 ? 0 : value)
  };

  return (
    <div>
      <Container>
        <Grid>
          <Grid.Row columns={2}>
            <Grid.Column >
              <Form className={cx(styles.form)}>
              <span className={styles.cardTitle} >Seek In Paperflite</span>
                <Grid className={styles.formGrid}>
                  <Grid.Row>
                    <Grid.Column>
                      <span className={cx(styles.title)}>
                        No. of questions per user per month
                      </span>
                      <Form.Field className={cx(styles.fieldName)}>
                        <Input
                          className={cx(styles.inputbox)}
                          value={limit}
                          type="number"
                          min={0}
                          onChange={(e,{value})=>handleSeekClick(value)}
                        />
                      </Form.Field>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
                <div className={cx(styles.savingbutton)}>
                  <Button
                    className={cx(styles.saving)}
                    onClick={() => handleSaveClick()}
                  >
                    Save
                  </Button>
                </div>
              </Form>
            </Grid.Column>

            <Grid.Column >
              <Form className={cx(styles.form)}>
              <span className={styles.cardTitle} >Seek In Fliteview</span>
                <Grid className={styles.formGrid}>
                  <Grid.Row>
                    <Grid.Column>
                      <span className={cx(styles.title)}>
                        No. of questions per visitor per day
                      </span>
                      <Form.Field className={cx(styles.fieldName)}>
                        <Input
                          className={cx(styles.inputbox)}
                          value={fliteViewSeekLimit}
                          type="number"
                          min={0}
                          onKeyDown={ (e) => (e.key === 'e' || e.key==='.' || e.key==='-' || e.key==='E') && e.preventDefault() }
                          onPaste={ (e) => (e.clipboardData.getData('text/plain').toLowerCase() === 'e' || e.clipboardData.getData('text/plain') ==='.' ||e.clipboardData.getData('text/plain')==='-') && e.preventDefault() }
                          onChange={(e)=>{
                            setFliteViewSeekLimit(e.target.value < 0 ? 0 : e.target.value)
                            if(e.target.value != account.visitorLimit){
                                setDisableSaveButton(false)
                              }else{
                                setDisableSaveButton(true)
                              }
                          }}
                        />
                      </Form.Field>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
                <div className={cx(styles.savingbutton)}>
                  <Button
                    className={cx(styles.saving)}
                    disabled={disableSaveButton}
                    onClick={() => handleSaveClick()}
                  >
                    Save
                  </Button>
                </div>
              </Form>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>

      <Suggestion />
    </div>
  );
}
